

import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  passwordActivate: any;
  
}


// WEBPACK FOOTER //
// ./src/app/services/tools/Globals.service.ts